import script from "./SchoolTrip.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolTrip.vue?vue&type=script&setup=true&lang=js"

import "./SchoolTrip.vue?vue&type=style&index=0&id=6f5c0ea4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5c0ea4"]])

export default __exports__